module.exports = __webpack_public_path__ + "img/L_301_0.864afa07.png";